<template>
    <div style="margin-top: 10.39mm;"
         :style="{'font-family':item.font,'font-size':item.fontSize}">
        <div v-if="item&&item.text">
            <div v-for="(text,index) in item.text.split('\n')" :key="index">
                <div v-if="index==0" style="float:left;margin-left: 2em;margin-right: 0.3em">附件：<span
                        v-if="item.sequence">1.</span></div>
                <div v-if="index!=0&&!item.sequence"
                     style="float:left;width: 5em;min-height: 1px;margin-right: 0.3em;"></div>
                <div v-if="index!=0&&item.sequence" style="float:left;margin-left: 5em;margin-right: 0.3em">
                    {{index+1}}.
                </div>
                <div v-html="convert(text)" style="overflow: auto;"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DocAttachment",
        props: {
            item: {}
        },
        methods: {
            convert(content, appendId) {
                return this.$tool.text2Html(content, appendId);
            },
        }
    }
</script>